import DownloadAppUI from "../../../components/molecules/common/DownloadAppUI";
import ResponsiveImage from "../../atoms/image/ResponsiveImage";
import Link from "next/link";

export default function FeaturedImage({
  data,
  imageAlign,
  contentAlign = "middle",
  className,
}) {
  const Description = ({ data }) => {
    return data.map((item, count) => {
      return (
        <p
          className="lg:mt-3 md:mt-1.5"
          dangerouslySetInnerHTML={{ __html: item }}
          key={count}
        />
      );
    });
  };
  const ImageLeft = ({ data }) => {
    return (
      <div
        className={`container grid--default has-align-${contentAlign} md:mb-10 lg:mb-15 ${
          className ? className : ""
        }`}
      >
        <ResponsiveImage
          width="560"
          height="400"
          imgClass="img-fit md:w-100"
          wrapClass="lg:maxw-lg"
          src={data.image.src}
          alt={data.image.alt}
          dpi={data.image.prefixes.dpi}
          mobile={data.image.prefixes.mobile}
          hasMobileImg={
            data.image.hasOwnProperty("hasMobileImg")
              ? data.image.hasMobileImg
              : true
          }
        />{" "}
        <article className="text-left lg:maxw-md">
          <h2
            className="text-lg md:mt-4 md:mb-2"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <Description data={data.desc} />
          {data.hasOwnProperty("downloadAppSection") && (
            <div className="download-app fx lg:mt-5 md:mt-2.5">
              <DownloadAppUI data={data.downloadAppSection} />
            </div>
          )}
        </article>
      </div>
    );
  };
  const ImageRight = ({ data }) => {
    const appMode = process.env.APP_MODE;
    const link = data?.cta?.href?.[appMode] || data?.cta?.href;
    return (
      <div
        className={`container grid--default has-align-${contentAlign} md:mb-10 lg:mb-15 md:fx md:fx--c ${className}`}
      >
        <article className="text-left lg:maxw-md fx--o-2">
          <h2
            className="text-lg md:mt-4 md:mb-2"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <Description data={data.desc} />
          {data.hasOwnProperty("downloadAppSection") && (
            <div className="download-app fx lg:mt-5 md:mt-2.5">
              <DownloadAppUI data={data.downloadAppSection} />
            </div>
          )}
          {data.hasOwnProperty("cta") && (
            <div className="download-app fx lg:mt-5 md:mt-2.5">
              <Link
                className="w-auto btn-secondary text-smx lg:pl-2.5 lg:pr-2.5 md:pl-2.5 md:pr-2.5"
                href={link}
                id={link}
              >
                {data.cta.text}
              </Link>
            </div>
          )}
        </article>{" "}
        <ResponsiveImage
          width="560"
          height="400"
          imgClass="img-fit md:w-100"
          wrapClass="lg:maxw-lg"
          src={data.image.src}
          alt={data.image.alt}
          dpi={data.image.prefixes.dpi}
          mobile={data.image.prefixes.mobile}
          hasMobileImg={
            data.image.hasOwnProperty("hasMobileImg")
              ? data.image.hasMobileImg
              : true
          }
        />{" "}
      </div>
    );
  };
  return Array.isArray(data) ? (
    data.map((item, count) => {
      imageAlign === "left" ? (
        <ImageLeft data={item} key={count} />
      ) : (
        <ImageRight data={item} key={count} />
      );
    })
  ) : imageAlign === "left" ? (
    <ImageLeft data={data} />
  ) : (
    <ImageRight data={data} />
  );
}
